import { useEffect } from 'react';
import { useMiniSearch } from 'react-minisearch';

import type { LinkItemProps } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';
import links from '~/modules/link-farm/linkFarmLinks.json';

const linkFarmItems: LinkItemProps[] = Object.values(links)
  .flat()
  .map((item, index) => ({
    minisearchID: index,
    icon: item.icon,
    appName: item.appName,
    url: item.url,
    actionText: item.actionText,
    category: item.category,
    requestAccess: item.requestAccess,
    requireVpn: item.requireVpn,
  }));

export const useSearch = (value: string) => {
  const { search, searchResults = [] } = useMiniSearch(linkFarmItems, {
    fields: ['appName', 'actionText', 'category', 'description'],
    storeFields: ['actionText'],
    idField: 'minisearchID',
  });

  useEffect(() => {
    search(value);
  }, [search, value]);

  return {
    artists: [],
    tracks: [],
    labels: [],
    tools: searchResults || [],
  };
};
